export default function NoBorderNoStyleButton({children, onClick}){
    return (
        <>
            <span className="cursor-pointer" onClick={onClick} >{children}</span>
        </>
    );
}